export const SUPER_ADMIN_ID = '99999999-9999-9999-9999-999999999999';
export const SYSTEM_USER_ID = '00000000-0000-0000-0000-000000000000';
